export default {
  SELECT_PRODUCT_CATEGORY: 'SELECT_PRODUCT_CATEGORY',

  SET_SESSION: 'SET_SESSION',
  FETCH_ENV_VARIABLES: 'FETCH_ENV_VARIABLES',
  FETCH_STORE_DETAILS: 'FETCH_STORE_DETAILS',
  GET_THEMES_ARRAY: 'GET_THEMES_ARRAY',
  FETCH_THEME_ELEMENTS: 'FETCH_THEME_ELEMENTS',
  FETCH_FONTS: 'FETCH_FONTS',
  FETCH_DEFAULT_COLORS: 'FETCH_DEFAULT_COLORS',
  FETCH_PATTERN_CONTENTS: 'FETCH_PATTERN_CONTENTS',
  FETCH_UNSPLASH_CONTENTS: 'FETCH_UNSPLASH_CONTENTS',
  FETCH_VECTEEZY_CONTENTS: 'FETCH_VECTEEZY_CONTENTS',
  FETCH_GETTY_IMAGE_CONTENTS: 'FETCH_GETTY_IMAGE_CONTENTS',
  FETCH_GETTY_IMAGE_BACKGROUND_CONTENTS:
    'FETCH_GETTY_IMAGE_BACKGROUND_CONTENTS',
  FETCH_GETTY_IMAGE_PHOTOS_CONTENTS: 'FETCH_GETTY_IMAGE_PHOTOS_CONTENTS',
  FETCH_GETTY_IMAGE_OBJECTS_CONTENTS: 'FETCH_GETTY_IMAGE_OBJECTS_CONTENTS',
  FETCH_I_STOCK_BACKGROUND_CONTENTS: 'FETCH_I_STOCK_BACKGROUND_CONTENTS',
  FETCH_I_STOCK_PHOTOS_CONTENTS: 'FETCH_I_STOCK_PHOTOS_CONTENTS',
  FETCH_I_STOCK_OBJECTS_CONTENTS: 'FETCH_I_STOCK_OBJECTS_CONTENTS',
  FETCH_ADOBE_STOCK_CONTENTS: 'FETCH_ADOBE_STOCK_CONTENTS',
  SET_SEARCH_CONTENTS: 'SET_SEARCH_CONTENTS',
  SET_MODAL_PAGE_MODE: 'SET_MODAL_PAGE_MODE',
  GET_STARTUP_SCENE: 'GET_STARTUP_SCENE',

  LOADER_ON_ADD_TO_ORDER: 'LOADER_ON_ADD_TO_ORDER',
  SELECT_DEFAULT_WALL_CHANGE: 'SELECT_DEFAULT_WALL_CHANGE',
  SELECT_CUSTOM_WALL_WIDTH: 'SELECT_CUSTOM_WALL_WIDTH',
  SELECT_CUSTOM_WALL_HEIGHT: 'SELECT_CUSTOM_WALL_HEIGHT',
  CUSTOM_WALL_ERROR: 'CUSTOM_WALL_ERROR',
  SET_COLOR_PICKER_SOURCE: 'SET_COLOR_PICKER_SOURCE',

  CHANGE_SIDEBAR_TAB: 'CHANGE_SIDEBAR_TAB',
  SET_FOLDER_LIST_ELEMENTS: 'SET_FOLDER_LIST_ELEMENTS',
  SET_SIDEBAR_VISIBILITY: 'SET_SIDEBAR_VISIBILITY',

  SET_TEXT_ID: 'SET_TEXT_ID',
  SET_CUSTOM_TEXT: 'SET_CUSTOM_TEXT',
  SET_FONT_FAMILY: 'SET_FONT_FAMILY',
  SET_FONT_PATH: 'SET_FONT_PATH',
  SET_TEXT_COLOR: 'SET_TEXT_COLOR',
  SET_SHADOW_COLOR: 'SET_SHADOW_COLOR',
  SET_TEXT_ALIGNMENT: 'SET_TEXT_ALIGNMENT',
  SET_TEXT_ATTRIBUTES: 'SET_TEXT_ATTRIBUTES',

  SET_LOADER_STATE: 'SET_LOADER_STATE',
  SET_UPLOAD_FILE: 'SET_UPLOAD_FILE',
  SET_ROOM_CANVAS: 'SET_ROOM_CANVAS',
  SET_WALL_CANVAS: 'SET_WALL_CANVAS',
  SET_BOTTOM_BAR_STATUS: 'SET_BOTTOM_BAR_STATUS',
  UPDATE_WINDOW_DIMENSIONS: 'UPDATE_WINDOW_DIMENSIONS',
  SET_ACTIVE_OBJECT: 'SET_ACTIVE_OBJECT',
  SET_ACTIVE_SELECTION: 'SET_ACTIVE_SELECTION',
  THEME_LOAD_PROGRESS: 'THEME_LOAD_PROGRESS',
  UPDATE_ACTIVE_OBJECT_COLORS: 'UPDATE_ACTIVE_OBJECT_COLORS',
  UPDATE_ROTATE_MODAL: 'UPDATE_ROTATE_MODAL',
  UPDATE_DRAGGING_MODAL: 'UPDATE_DRAGGING_MODAL',
  UPDATE_PENDING_PROMISES: 'UPDATE_PENDING_PROMISES',
  UPDATE_PHOTO_ELEMENTS: 'UPDATE_PHOTO_ELEMENTS',
  UPDATE_ELEMENTS: 'UPDATE_ELEMENTS',
  UPDATE_PROGRESS_DATA: 'UPDATE_PROGRESS_DATA',
  UPDATE_PROJECT_NAME: 'UPDATE_PROJECT_NAME',
  UPDATE_SCENE_ELEMENTS: 'UPDATE_SCENE_ELEMENTS',
  UPDATE_THEMES_ARRAY: 'UPDATE_THEMES_ARRAY',
  UPDATE_SCALAR_MODAL: 'UPDATE_SCALAR_MODAL',
  UPDATE_TRANSPARENCY_MODAL: 'UPDATE_TRANSPARENCY_MODAL',

  SET_OR_HIDE_SEARCH_BAR: 'SET_OR_HIDE_SEARCH_BAR',
  SET_COLOR_TO_SEARCH: 'SET_COLOR_TO_SEARCH',
  UNIT_SYSTEM_CHANGED: 'UNIT_SYSTEM_CHANGED',
  ORIENTATION_CHANGED: 'ORIENTATION_CHANGED',
  CONTRAST_CHANGED: 'CONTRAST_CHANGED',
  LANGUAGE_CHANGED: 'LANGUAGE_CHANGED',

  SET_SAVE_STATE: 'SET_SAVE_STATE',
  ELEMEMT_LIST_UNMOUNT: 'ELEMEMT_LIST_UNMOUNT',
  SET_SHOULD_LOAD_MORE_CONTENTS: 'SET_SHOULD_LOAD_MORE_CONTENTS',
  SHOW_LOADING_DIALOG: 'SHOW_LOADING_DIALOG',
  SET_SEARCH_TAGS: 'SET_SEARCH_TAGS',
  SET_OLD_SEARCH_TAGS: 'SET_OLD_SEARCH_TAGS',
  SET_VECTEEZY_PLACEHOLDER: 'SET_VECTEEZY_PLACEHOLDER',
  SET_UNSPLASH_PLACEHOLDER: 'SET_UNSPLASH_PLACEHOLDER',

  SET_DOCUMENT_COLORS: 'SET_DOCUMENT_COLORS',
  CHANGE_TEMPLATES_TAB: 'CHANGE_TEMPLATES_TAB',
  SET_INSPIRATION_CATEGORY: 'SET_INSPIRATION_CATEGORY',
  SET_INSPIRATIONS: 'SET_INSPIRATIONS',
  SET_INSPIRATION_OFFSET: 'SET_INSPIRATION_OFFSET',
  SET_INSPIRATION_FILTER: 'SET_INSPIRATION_FILTER',
  PATTERN_DATA_AVAILABILITY: 'PATTERN_DATA_AVAILABILITY',
  SET_UPLOAD_FILE_STATUS: 'SET_UPLOAD_FILE_STATUS',
  SET_UPLOAD_CONTENTS: 'SET_UPLOAD_CONTENTS',
  SET_UPLOAD_USER_PHOTO_TYPE: 'SET_UPLOAD_USER_PHOTO_TYPE',
  SET_THEME: 'SET_THEME',
  SET_LOCK_PROPERTY: 'SET_LOCK_PROPERTY',
  SET_DRAGGED_POSITION: 'SET_DRAGGED_POSITION',
  MATERIAL_INDEX: 'MATERIAL_INDEX',
  SET_DROPBOX_UPLOAD_DIALOG: 'SET_DROPBOX_UPLOAD_DIALOG',
  SET_DROPBOX_FILES: 'SET_DROPBOX_FILES',
  HELP_WINDOW_STATUS: 'HELP_WINDOW_STATUS',
  HELP_CHECKBOX: 'HELP_CHECKBOX',
  SET_SHOW_PIXELATION_WARNING_FIELD: 'SET_SHOW_PIXELATION_WARNING_FIELD',
  SHOW_PIXELATION_WINDOW_DIALOGUE: 'SHOW_PIXELATION_WINDOW_DIALOGUE',
  SHOW_REQUEST_SAMPLE_WINDOW: 'SHOW_REQUEST_SAMPLE_WINDOW',
  SHOW_ORDER_SAMPLE_DETAILS_WINDOW: 'SHOW_ORDER_SAMPLE_DETAILS_WINDOW',
  SET_ORDER_SAMPLE_DETAILS: 'SET_ORDER_SAMPLE_DETAILS',
  SET_SHARE_OPTION_FOR_ORDER: 'SET_SHARE_OPTION_FOR_ORDER',
  SET_SEND_PREVIEW_WITH_LOUPE: 'SET_SEND_PREVIEW_WITH_LOUPE',
  SET_SELECTED_TOOL: 'SET_SELECTED_TOOL',
  SET_FILTERED_TOOLS: 'SET_FILTERED_TOOLS',
  SET_IS_UPLOAD_LOGO: 'SET_IS_UPLOAD_LOGO',
  SHOW_LOADING_ICON: 'SHOW_LOADING_ICON',
  SET_SHARE_LINK_TYPE: 'SET_SHARE_LINK_TYPE',
  SET_GROUP_PROPERTY: 'SET_GROUP_PROPERTY',
  SET_PAGE_INDEX: 'SET_PAGE_INDEX',
  SETUP_PAGES: 'SETUP_PAGES',
  RECOLOR: 'RECOLOR',
  STORE_RECOLOR_ARRAY: 'STORE_RECOLOR_ARRAY',
  SET_WEB_LINK_SAVE: 'SET_WEB_LINK_SAVE',
  SET_FOLDER_FOR_WEB_LINK: 'SET_FOLDER_FOR_WEB_LINK',
  SET_WEB_USER_INFO: 'SET_WEB_USER_INFO',
  PREMIUM_CONTENT_LOGIN_FAILED: 'PREMIUM_CONTENT_LOGIN_FAILED',
  PATTERN_DESIGN_LOGIN_SUCCESS: 'PATTERN_DESIGN_LOGIN_SUCCESS',
  PATTERN_DESIGN_LOGOUT_SUCCESS: 'PATTERN_DESIGN_LOGOUT_SUCCESS',
  VECTEEZY_LOGOUT_SUCCESS: 'VECTEEZY_LOGOUT_SUCCESS',
  VECTEEZY_LOGIN_WINDOW: 'VECTEEZY_LOGIN_WINDOW',
  PATTERN_DESIGN_LOGIN_WINDOW: 'PATTERN_DESIGN_LOGIN_WINDOW',
  SET_SHOW_VANILLA_LOGIN_DIALOGUE: 'SET_SHOW_VANILLA_LOGIN_DIALOGUE',
  CHANGE_MATERIAL_TAB: 'CHANGE_MATERIAL_TAB',
  SET_ALL_EXTERNAL_PROJECTS: 'SET_ALL_EXTERNAL_PROJECTS',
  SET_DIALOGUE_PARAMS: 'SET_DIALOGUE_PARAMS',
  SET_DIALOGUE_FLAG: 'SET_DIALOGUE_FLAG',
  MAKE_PROJECT_DIRTY: 'MAKE_PROJECT_DIRTY',
  SET_WB_LINK_SAVE_FOLDER_TYPE: 'SET_WB_LINK_SAVE_FOLDER_TYPE',
  SET_ROOT_FOLDERS: 'SET_ROOT_FOLDERS',
  TRIGGER_COMPONENT_REDRAW: 'TRIGGER_COMPONENT_REDRAW',
  REGISTER_ACCOUNT_FAILED: 'REGISTER_ACCOUNT_FAILED',
  REGISTER_WINDOW: 'REGISTER_WINDOW',
  REGISTER_WINDOW_PATTERN: 'REGISTER_WINDOW_PATTERN',
  REGISTER_WINDOW_DREAMSTIME: 'REGISTER_WINDOW_DREAMSTIME',
  SET_WEB_LINK_FIRST_SAVE: 'SET_WEB_LINK_FIRST_SAVE',
  SET_WEB_LINK_SAVE_IDENTIFIER: 'SET_WEB_LINK_SAVE_IDENTIFIER',
  REDIRECT_TO_CONGRATULATIONS_PAGE: 'REDIRECT_TO_CONGRATULATIONS_PAGE',
  SHOW_OR_HIDE_PRINTER_DETAILS_DIALOG: 'SHOW_OR_HIDE_PRINTER_DETAILS_DIALOG',
  USER_LIST: 'USER_LIST',
  PRINTERS_LIST: 'PRINTERS_LIST',
  FAIL_TO_ADD_PRINTER: 'FAIL_TO_ADD_PRINTER',
  SET_SHARE_MEDIUM: 'SET_SHARE_MEDIUM',
  SET_IFRAME: 'SET_IFRAME',
  SET_DEFAULT_MASK_STEP_FOR_ORDER_SAMPLE:
    'SET_DEFAULT_MASK_STEP_FOR_ORDER_SAMPLE',
  IS_MAXIMUM_LIMIT: 'IS_MAXIMUM_LIMIT',
  PATTERN_DESIGN_COST: 'PATTERN_DESIGN_COST',
  SET_PROJECT_INITIATED: 'SET_PROJECT_INITIATED',
  MAKE_PROJECT_DIRTY_WITH_NO_UNDO_SUPPORT:
    'MAKE_PROJECT_DIRTY_WITH_NO_UNDO_SUPPORT',
  ALL_CONTENTS_FETCHED: 'ALL_CONTENTS_FETCHED',
  SET_EXTERNAL_USER_ID: 'SET_EXTERNAL_USER_ID',
  SET_INSPIRATION_FONTS: 'SET_INSPIRATION_FONTS',
  UPDATE_WITH_INSPIRATION_FONTS: 'UPDATE_WITH_INSPIRATION_FONTS',
  FETCH_DREAMSTIME_CONTENTS: 'FETCH_DREAMSTIME_CONTENTS',
  DREAMSTIME_LOGIN_WINDOW: 'DREAMSTIME_LOGIN_WINDOW',
  SET_DREAMSTIME_USER_LOGGED_IN: 'SET_DREAMSTIME_USER_LOGGED_IN',
  DREAMSTIME_USER_INFO: 'DREAMSTIME_USER_INFO',
  DREAMSTIME_LOGIN_SUCCESS: 'DREAMSTIME_LOGIN_SUCCESS',
  SET_GETTY_IMAGE_PLACEHOLDER: 'SET_GETTY_IMAGE_PLACEHOLDER',
  SET_GETTY_IMAGE_BACKGROUND_PLACEHOLDER:
    'SET_GETTY_IMAGE_BACKGROUND_PLACEHOLDER',
  SET_GETTY_IMAGE_PHOTOS_PLACEHOLDER: 'SET_GETTY_IMAGE_PHOTOS_PLACEHOLDER',
  SET_GETTY_IMAGE_OBJECTS_PLACEHOLDER: 'SET_GETTY_IMAGE_OBJECTS_PLACEHOLDER',
  SET_I_STOCK_BACKGROUND_PLACEHOLDER: 'SET_I_STOCK_BACKGROUND_PLACEHOLDER',
  SET_I_STOCK_PHOTOS_PLACEHOLDER: 'SET_I_STOCK_PHOTOS_PLACEHOLDER',
  SET_I_STOCK_OBJECTS_PLACEHOLDER: 'SET_I_STOCK_OBJECTS_PLACEHOLDER',
  SET_DROPBOX_FILE_INDEX: 'SET_DROPBOX_FILE_INDEX',
  SET_FILE_SIZE: 'SET_FILE_SIZE',
  SET_UPLOAD_FILE_PERCENTAGE: 'SET_UPLOAD_FILE_PERCENTAGE',
  SET_INSTAGRAM_CONTENTS: 'SET_INSTAGRAM_CONTENTS',
  SET_INSTAGRAM_NEXT_URL: 'SET_INSTAGRAM_NEXT_URL',
  HANDLE_BOTTOM_BREADCRUMB_CLICK: 'HANDLE_BOTTOM_BREADCRUMB_CLICK',
  SET_UPLOAD_ERROR_FLAG: 'SET_UPLOAD_ERROR_FLAG',
  SET_INSTAGRAM_LOGIN_FLAG: 'SET_INSTAGRAM_LOGIN_FLAG',
  SET_LOADER_COORDINATES: 'SET_LOADER_COORDINATES',
  SET_SELECTED_OBJECTS: 'SET_SELECTED_OBJECTS',
  RERENDER_FLAG: 'RERENDER_FLAG',
  DROPBOX_ERROR_FLAG: 'DROPBOX_ERROR_FLAG',
  DROPBOX_ERROR_PARAMS: 'DROPBOX_ERROR_PARAMS',
  REDRAW_CANVAS: 'REDRAW_CANVAS',
  WALL_SIZE_CHANED_FLAG: 'WALL_SIZE_CHANED_FLAG',
  ENTER_VIEW_ONLY_PREVIEW_MODE: 'ENTER_VIEW_ONLY_PREVIEW_MODE',
  SET_FEEDBACK_DIALOGUE: 'SET_FEEDBACK_DIALOGUE',
  SET_FEEDBACK_STATE: 'SET_FEEDBACK_STATE',
  UPDATE_TOOL_DRAG_MODAL: 'UPDATE_TOOL_DRAG_MODAL',
  SET_PROJECT_SUBMISSION_STATE: 'SET_PROJECT_SUBMISSION_STATE',
  TAB_USAGE_DURATION: 'TAB_USAGE_DURATION',
  ZOOM_IN_MODE: 'ZOOM_IN_MODE',
  ZOOM_OUT_MODE: 'ZOOM_OUT_MODE',
  SET_SOLID_BACKGROUND_COLOR: 'SET_SOLID_BACKGROUND_COLOR',
  FLASH_MESSAGE: 'FLASH_MESSAGE',
  SET_THEME_RESPONSE: 'SET_THEME_RESPONSE',
  ADOBE_STOCK_USER_INFO: 'ADOBE_STOCK_USER_INFO',
  SET_ADOBE_STOCK_USER_LOGGED_IN: 'SET_ADOBE_STOCK_USER_LOGGED_IN',
  FETCH_HP_MOSAIC_DATA: 'FETCH_HP_MOSAIC_DATA',
  SET_VIEW_TYPE: 'SET_VIEW_TYPE',
  SET_IS_3D_VIEW_LOADED: 'SET_IS_3D_VIEW_LOADED',
  SET_INITIAL_LOADER: 'SET_INITIAL_LOADER',
  REFRESH_3D: 'REFRESH_3D',
  SET_SELECTED_PRODUCT: 'SET_SELECTED_PRODUCT',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',
  UPDATE_THEME_ELEMENTS: 'UPDATE_THEME_ELEMENTS',
  SET_FEEDBACK_RATING: 'SET_FEEDBACK_RATING',
  SET_FEEDBACK_REVIEW: 'SET_FEEDBACK_REVIEW',
  SET_SVG_REFERENCE_ID: 'SET_SVG_REFERENCE_ID',
  SEND_REVIEW_ORDER_GA: 'SEND_REVIEW_ORDER_GA',
  SET_IS_DROPBOX_HIDDEN: 'SET_IS_DROPBOX_HIDDEN',
  SET_IS_INSTAGRAM_HIDDEN: 'SET_IS_INSTAGRAM_HIDDEN',
  SET_SINGLE_PRODUCT: 'SET_SINGLE_PRODUCT',
  SET_FEEDBACK_PERMISSION_STATE: 'SET_FEEDBACK_PERMISSION_STATE',
  SET_PROJECT_STRUCTURE: 'SET_PROJECT_STRUCTURE',
  BLOCKCHAIN_TRANSACTION_IN_PROGRESS: 'BLOCKCHAIN_TRANSACTION_IN_PROGRESS',
  SET_INITIAL_PIXELATION_DIALOG_SHOWN: 'SET_INITIAL_PIXELATION_DIALOG_SHOWN',
  UPDATE_PRODUCT_SIZES: 'UPDATE_PRODUCT_SIZES',
  UPDATE_NON_PIXELATED_DIMENION: 'UPDATE_NON_PIXELATED_DIMENION',
  SET_AVAILABLE_PROJECT_SIZES: 'SET_AVAILABLE_PROJECT_SIZES',
  SET_ORDER_FORM_DETAILS: 'SET_ORDER_FORM_DETAILS',
  TEMPLATE_SELECTION_DIALOGUE: 'TEMPLATE_SELECTION_DIALOGUE',
  SET_MULTIWALL_PROJECTS: 'SET_MULTIWALL_PROJECTS',
  SET_ACTIVE_MULTIWALL_PROJECT_INDEX: 'SET_ACTIVE_MULTIWALL_PROJECT_INDEX',
  SET_LEFT_WALL_PREVIEWS: 'SET_LEFT_WALL_PREVIEWS',
  SET_RIGHT_WALL_PREVIEWS: 'SET_RIGHT_WALL_PREVIEWS',
  SET_INSTAGRAM_RETRY_COUNT: 'SET_INSTAGRAM_RETRY_COUNT',
  FETCH_WALL_LAYOUTS: 'FETCH_WALL_LAYOUTS',
  SET_PREVIOUS_ACTIVE_OBJECT: 'SET_PREVIOUS_ACTIVE_OBJECT',
  BACKUP_ACTIVE_PROJECT: 'BACKUP_ACTIVE_PROJECT',
  SET_PROJECT_SIZE: 'SET_PROJECT_SIZE',
  SET_BACKUP_PROJECT_SIZE: 'SET_BACKUP_PROJECT_SIZE',
  SET_CANVAS_TYPE: 'SET_CANVAS_TYPE',
  SET_ROW: 'SET_ROW',
  SET_COLUMN: 'SET_COLUMN',
  SET_MULTI_CANVAS_ERROR: 'SET_MULTI_CANVAS_ERROR',
  SET_CANVAS_WALL_HEIGHT: 'SET_CANVAS_WALL_HEIGHT',
  SET_CANVAS_WALL_WIDTH: 'SET_CANVAS_WALL_WIDTH',
  SET_MULTICANVAS_POPOVER_STATUS: 'SET_MULTICANVAS_POPOVER_STATUS',
  SET_COLUMN_VALID: 'SET_COLUMN_VALID',
  SET_ROW_VALID: 'SET_ROW_VALID',
  SET_CANVAS_WALL_WIDTH_VALID: 'SET_CANVAS_WALL_WIDTH_VALID',
  SET_CANVAS_WALL_HEIGHT_VALID: 'SET_CANVAS_WALL_HEIGHT_VALID',
  SET_CANVAS_WALL_ERROR: 'SET_CANVAS_WALL_ERROR',
  SET_VALID_PROJECT: 'SET_VALID_PROJECT',
  SET_SAVE_VIA_WALL_NAVIGATION: 'SET_SAVE_VIA_WALL_NAVIGATION',
  SET_SHARED_SCENE_DATA: 'SET_SHARED_SCENE_DATA',
  SET_PROJECT_GROUP_SHARED_SCENE: 'SET_PROJECT_GROUP_SHARED_SCENE',
  SET_DRAGGABLE_CANVAS_POSITION: 'SET_DRAGGABLE_CANVAS_POSITION',
  SET_RIGHT_PREVIEW_IN_PROGESS: 'SET_RIGHT_PREVIEW_IN_PROGESS',
  SET_LEFT_PREVIEW_IN_PROGESS: 'SET_LEFT_PREVIEW_IN_PROGESS',
  SET_WIDTH_SIZE_VALIDATIONS: 'SET_WIDTH_SIZE_VALIDATIONS',
  SET_HEIGHT_SIZE_VALIDATIONS: 'SET_HEIGHT_SIZE_VALIDATIONS',
  SET_ACTIVE_STICKER_ID: 'SET_ACTIVE_STICKER_ID',
  SET_STICKER_ID_LIST: 'SET_STICKER_ID_LIST',
  SET_STICKER_PREVIEW_LIST: 'SET_STICKER_PREVIEW_LIST',
  SET_ENABLE_OR_DIABLE_STICKER_DRAG: 'SET_ENABLE_OR_DIABLE_STICKER_DRAG',
  SET_STICKER_COUNTER: 'SET_STICKER_COUNTER',
  SET_VISUALIZE_STICKER_COUNTER: 'SET_VISUALIZE_STICKER_COUNTER',
  SET_REFRESH_STICKER_PREVIEW: 'SET_REFRESH_STICKER_PREVIEW'
};
